"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetAggregatedTextAttributes = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const attributes_utils_1 = require("./attributes.utils");
const client_constants_1 = require("../../client.constants");
const client_utils_1 = require("../../client.utils");
const hooks_1 = require("../../hooks");
const gql_1 = require("../gql");
// merge the new part with an already loaded
const updateQuery = (previousResult, options) => {
    var _a, _b;
    const { edges: prevAttributes = [] } = (_a = previousResult.productTreeNode.productAggregatedLabelsNew) !== null && _a !== void 0 ? _a : {};
    const { productTreeNode } = (_b = options === null || options === void 0 ? void 0 : options.fetchMoreResult) !== null && _b !== void 0 ? _b : {};
    const _c = productTreeNode.productAggregatedLabelsNew, { edges = [] } = _c, productAggregatedLabelsNew = __rest(_c, ["edges"]);
    return {
        productTreeNode: Object.assign(Object.assign(Object.assign({}, previousResult.productTreeNode), productTreeNode), { productAggregatedLabelsNew: Object.assign(Object.assign({}, productAggregatedLabelsNew), { edges: [...prevAttributes, ...edges] }) }),
    };
};
const fetchMoreOptions = { updateQuery };
/**
 *
 * @returns Aggregated attributes associated with products,
 * covering the selected node and all its children.
 *
 * Behavior controlled by the `isRequirement` filter flag:
 * - If disabled (default behavior): Only attributes associated with products (`at least one value has productCount > 0`) are included.
 * - If enabled: Includes "In Strategy" attributes that are not associated with any products (`productCount = 0`),
 *   but excludes attributes associated with products if they are not "In Strategy."
 *   (Valid product attributes + rest "In Strategy" attributes)
 */
const useGetAggregatedTextAttributes = ({ catalogId, productTreeNodeId, sortingItem, isRequirement, pageSize = client_constants_1.PAGE_SIZE_LARGE, filter, options, }) => {
    var _a, _b;
    const sort = attributes_utils_1.sortingItemToAggregatedAttributesSortMap[sortingItem];
    const mergedFilter = (0, react_1.useMemo)(() => (0, attributes_utils_1.getAggregatedAttributesFilter)(filter, isRequirement), [filter, isRequirement]);
    const { data, error, networkStatus, variables, fetchMore, } = (0, react_2.useQuery)(gql_1.GET_AGGREGATED_TEXT_ATTRIBUTES, {
        notifyOnNetworkStatusChange: true,
        variables: {
            productTreeNodeId: productTreeNodeId !== null && productTreeNodeId !== void 0 ? productTreeNodeId : '',
            catalogId,
            sort,
            filter: mergedFilter,
            first: pageSize,
            before: null,
            after: null,
            last: null,
        },
        skip: !productTreeNodeId || !catalogId || (options === null || options === void 0 ? void 0 : options.skip),
    });
    const { edges, pageInfo } = (_b = (_a = data === null || data === void 0 ? void 0 : data.productTreeNode) === null || _a === void 0 ? void 0 : _a.productAggregatedLabelsNew) !== null && _b !== void 0 ? _b : {};
    const pagination = (0, hooks_1.usePagination)({
        pageInfo,
        networkStatus,
        pageSize,
        fetchMore,
        fetchMoreOptions,
        lastVariables: variables,
    });
    return {
        data: edges,
        isLoading: (0, client_utils_1.isQueryLoadingOrRefetching)(networkStatus),
        isRefetching: (0, client_utils_1.isQueryRefetching)(networkStatus),
        error,
        pagination,
    };
};
exports.useGetAggregatedTextAttributes = useGetAggregatedTextAttributes;
